export default __webpack_public_path__ + "static/media/help_triangle.84a14050.svg";